import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
import { money } from "@/lib/format";

export default function TradeIn() {
  const { user } = useAuth();
  const [balance, setBalance] = useState(0);

  useEffect(() => {
    if (user) api.get("/credits/balance").then((res) => setBalance(res.data.balance));
  }, [user]);

  return (
    <div data-testid="trade-in-page">
      <section className="container-lookers py-24 max-w-2xl">
        <h1 className="font-serif text-5xl sm:text-6xl mb-5 text-zinc-900">
          Ready For Another Look?
        </h1>
        <p className="text-sm text-zinc-500 mb-8">Trade your current designer frames back to Lookers and put their value toward another pair. Another look for your old frames. Another look for you.</p>
        {user && balance > 0 && (
          <div className="border border-zinc-200 rounded-sm p-5 mb-8 inline-block bg-white">
            <div className="text-xs font-heading uppercase text-zinc-400">Your Lookers Credit</div>
            <div className="font-serif text-3xl text-teal-700">{money(balance)}</div>
          </div>
        )}
        <div className="flex gap-4">
          <Link to="/sell" className="bg-teal-600 hover:bg-teal-700 text-ink px-6 py-3.5 text-xs font-heading font-semibold uppercase tracking-wide rounded-full transition-colors" data-testid="tradein-start-button">Start A Trade-In</Link>
          <Link to="/shop" className="border border-zinc-200 hover:border-teal-600 hover:text-teal-700 text-zinc-800 px-6 py-3.5 text-xs font-heading font-semibold uppercase tracking-wide rounded-full transition-colors" data-testid="tradein-shop-button">Shop Frames</Link>
        </div>
      </section>

      <section className="bg-white py-16 border-y border-zinc-100">
        <div className="container-lookers grid md:grid-cols-3 gap-10 text-sm">
          <div>
            <div className="font-serif text-3xl mb-2 text-teal-600">01</div>
            <p className="text-zinc-500">Tell us about the designer frames you'd like to trade in.</p>
          </div>
          <div>
            <div className="font-serif text-3xl mb-2 text-teal-600">02</div>
            <p className="text-zinc-500">We assess them and offer trade-in credit — usually higher than a cash offer.</p>
          </div>
          <div>
            <div className="font-serif text-3xl mb-2 text-teal-600">03</div>
            <p className="text-zinc-500">Apply your Lookers Credit toward your next pair, in full or in part.</p>
          </div>
        </div>
      </section>
    </div>
  );
}
